export class UserSettingKeys {
  public static readonly CurrencyPrefix = "CURRENCY_PREFIX";
  public static readonly GST = "GST";
  public static readonly ProductPrefix = "PRODUCT_PREFIX";
  public static readonly CategoryPrefix = "CATEGORY_PREFIX";
  public static readonly SubCategoryPrefix = "SUBCATEGORY_PREFIX";
  public static readonly CustomerPrefix = "CUSTOMER_PREFIX";
  public static readonly SupplierPrefix = "SUPPLIER_PREFIX";
  public static readonly SalePrefix = "SALE_PREFIX";
  public static readonly SaleReturnPrefix = "SALE_RETURN_PREFIX";
  public static readonly PurchaseReturnPrefix = "PURCHASE_RETURN_PREFIX";
  public static readonly PurchasePrefix = "PURCHASE_PREFIX";
  public static readonly BrandPrefix = "BRAND_PREFIX";
  public static readonly ExpensePrefix = "EXPENSE_PREFIX";
}

export class GlobalUserSettingValues {
  public static CurrencyPrefix = "";
}
